import { SupplierJobEdit } from '@client/components/suppliers/SupplierJobEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { claimFormStore } from '@client/routes/~console.$orgId/~claims/~details.$id/store';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

const searchSchema = z.object({
    newSupplierId: z.string().optional(),
    newSupplierEmail: z.email().optional().or(z.literal('')),
    newSupplierPhone: z.string().optional(),
});

export const Route = createFileRoute('/console/$orgId/claims/details/$id/manage/supplier-jobs/add')({
    validateSearch: searchSchema,
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add job',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const isReadonly = claimFormStore.use.isReadonly();
    const navigate = useNavigate();

    // CUR-725: closed claims are read-only — no new jobs.
    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return <SupplierJobEdit action={['add']} claimId={Route.useParams().id} />;
}
